import "dotenv/config";
import { Command } from "commander";

import packageJson from "@/package.json" with { type: "json" };
import { assetsCmd } from "@/src/commands/assets/index.ts";
import { generateCmd } from "@/src/commands/generate/index.ts";
import { stylesCmd } from "@/src/commands/styles/index.ts";
import { variablesCmd } from "@/src/commands/variables/index.ts";
import { checkForUpdate } from "@/src/utils/check-for-update.ts";
import { globalOptions } from "@/src/utils/options.ts";
import { showVersion } from "@/src/utils/show-version.ts";

export async function main() {
  const program = new Command()
    .name("zeytal")
    .description("From Figma to code in only one command line.")
    .version(
      packageJson.version || "1.0.0",
      "-v, --version",
      "display the version number",
    );

  // Add global options
  globalOptions.forEach((o) => {
    program.addOption(o);
  });

  program
    .addCommand(assetsCmd)
    .addCommand(stylesCmd)
    .addCommand(variablesCmd)
    .addCommand(generateCmd, { isDefault: true });

  showVersion();

  await checkForUpdate(packageJson.name, packageJson.version).catch(() => {
    // Silently handle errors
  });

  await program.parseAsync();
}
